import type { Account, CloudAccountConfiguration } from '@repo/api-gw-sdk';

import { PanelWrapper } from '@/components/panels/panelWrapper';

import { RestoreAccountConfigTabs } from './restoreAccountConfigTabs';

interface RestoreAccountConfigPanelProps {
  account: Account;
  config: CloudAccountConfiguration;
  onSave: (
    account: Account,
    entity: CloudAccountConfiguration
  ) => Promise<void>;
  onAbort: () => void;
}

export function RestoreAccountConfigPanel(
  props: RestoreAccountConfigPanelProps
) {
  return (
    <PanelWrapper
      testIdPrefix='restore-account-config'
      header={{
        hideBorder: true,
        title: 'Restore Account Configuration',
        onBack: props.onAbort,
        onClose: props.onAbort,
      }}
    >
      <RestoreAccountConfigTabs
        account={props.account}
        config={props.config}
        onAbort={props.onAbort}
        onSave={props.onSave}
      />
    </PanelWrapper>
  );
}
